'use client';

import { Box, Button, Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useEffect } from 'react';

export default function RootError({ error, reset }) {
	useEffect(() => {
		// Log the error to an error reporting service
		console.error(error);
	}, [error]);

	return (
		<Box
			sx={{
				bgcolor: '#F4F2F0',
				minHeight: '100vh',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			}}>
			<Stack spacing={3} alignItems="center" sx={{ textAlign: 'center', px: 2 }}>
				<Typography variant="h4">Something went wrong</Typography>
				<Typography variant="body1" color="text.secondary" sx={{ maxWidth: 500 }}>
					An unexpected error occurred. You can try again.
				</Typography>
				<Button variant="contained" color="lumoraGreenPrimary" onClick={() => reset()}>
					Try again
				</Button>
			</Stack>
		</Box>
	);
}

RootError.propTypes = {
	error: PropTypes.object.isRequired,
	reset: PropTypes.func.isRequired
};
